export const KEY_CA_VOUCHER_TOASTER = 'KEY_CA_VOUCHER_TOASTER';
export const KEY_CA_EA_TOASTER = 'KEY_CA_EA_TOASTER';
export const KEY_BE_ABTASTY_EVENTS = 'KEY_BE_ABTASTY_EVENTS';
